import RealAux from './../../hoc/RealAux';
import LinkInfo from "./LinkInfo";
import LinksDetails from "./LinksDetails";

const Links = function (props) {
    if(props.layout == 'first'){
        return (
            <React.Fragment>
                {props.items.map((item,index) => (
                <LinkInfo data={item} siteUrl={props.siteUrl} isQuest={props.isQuest}  key={"LinksDetails_"+index}/>
            )) }
            </React.Fragment>
        );
    }
    else{
            return (
                <React.Fragment>
                    {props.items.map((item,index) => (
                    <LinksDetails data={item} key={"LinksDetails_"+index}/>
                )) }
                </React.Fragment>
            )
        }
}

export default Links;